// Client for the FastAPI demo backend (proxied by nginx at /api/demo).
// Override the base with REACT_APP_DEMO_API for split-origin local dev.
const BASE = process.env.REACT_APP_DEMO_API || "/api/demo";

async function post(path, body) {
  const resp = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data = null;
  try {
    data = await resp.json();
  } catch {
    /* non-JSON */
  }
  if (!resp.ok) {
    const detail = (data && (data.detail || data.message)) || `HTTP ${resp.status}`;
    throw new Error(typeof detail === "string" ? detail : "request failed");
  }
  return data;
}

export function demoStart({ name, email, language, whatsapp }) {
  return post("/start", { name, email, language, whatsapp });
}

export function demoResend({ demoId }) {
  return post("/resend", { demo_id: demoId });
}

export function demoVerify({ demoId, token }) {
  return post("/verify", { demo_id: demoId, token });
}

export async function demoResult(ref) {
  const resp = await fetch(`${BASE}/result/${encodeURIComponent(ref)}`);
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json();
}
